export const MobileFobTitle = {
  2910: 'Shop All Women',
  16961: 'Shop All Shoes',
  16958: 'Shop All Handbags & Wallets',
  3376: 'Shop All Jewelry & Accessories',
  2921: 'Shop All Beauty',
  3864: 'Shop All Men',
  3866: 'Shop All Kids',
  3865: 'Shop All Home',
  3977: 'Shop All Sale',
  3948: 'Shop All Gifts',
};

export default MobileFobTitle;
